var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.3 511.3",
    style: {
      enableBackground: "new 0 0 511.3 511.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF4A00;}\r\n\t.st1{fill:#FAE056;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.5,506.6c-37.3-12.8-71.5-36.2-92.8-69.3c-18.1-27.7-26.6-61.8-30.9-94.9c-3.2-29.9-4.2-60.8,1.1-90.7 s16-53.3,35.2-76.8c-5.3,20.3-2.1,41.6,4.3,61.9c6.4,20.2,17.1,38.4,26.7,56.5c1.1-35.2,18.2-67.2,36.3-98.1s38.4-60.8,48-94.9 C227,66.1,223.8,25.6,199.3,0c49.1,18.1,96,44.9,130.1,85.4s51.2,96,40.5,147.2c18.1-20.3,27.7-48,25.6-74.7 c24.6,30.9,41.6,67.2,49.1,105.6s3.2,78.9-11.7,114.1c-15,33.1-38.4,60.8-61.9,87.5C320.9,508.8,255.8,518.4,189.5,506.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.4,410.7c1-26.7-9.6-53.4-26.7-73.6c-1.1,20.3-12.8,39.5-28.8,51.2c13.9-28.8,18.2-63,10.7-93.9 s-25.6-59.7-51.2-78.9c6.4,27.7-4.2,55.5-18.1,80c-13.9,23.5-32,45.9-44.8,70.4c-12.8,25.6-20.3,55.5-9.6,81.1 c-20.3-18.2-31-50.2-26.7-93.9c0,1-1.1,1-1.1,2.1c-48,80,38.4,183.4,125.9,149.3C327.3,489.6,360.4,452.3,360.4,410.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.8f5972292fee2bf452bf547c900eb06f.svg";
export { ForwardRef as ReactComponent };